import React from "react"
import PropTypes from "prop-types"
import { useIntl } from "gatsby-plugin-react-intl"
import styled from "styled-components"

import Link from "./Link"

import { mixins, media } from "../styles"
import ArrowRightSVG from "../images/icons/arrow-right.inline.svg"

const Teaser = styled(Link)`
  background: ${({ theme }) => theme.greyLight};
  color: ${({ theme }) => theme.spaceblue};
  margin: 0 10px 20px;
  text-decoration: none;
  transition: color ${({ theme }) => theme.transitionTime};

  > span {
    display: flex;

    flex-direction: column;
    padding: 25px 30px;
  }

  &:hover {
    color: ${({ theme }) => theme.sun};
  }

  @media ${media.md} {
    min-height: 190px;
    width: calc(50% - 20px);

    > span {
      height: 100%;
    }
  }

  @media ${media.lg} {
    min-height: 120px;
    width: calc(33.3333333% - 20px);
  }
`

const TeaserText = styled.div`
  margin: 0 0 10px;

  h3 {
    ${mixins.title6}
  }

  p {
    ${mixins.copy4}
  }
`

const ReadMore = styled.span`
  ${mixins.copy4}
  align-Teasers: center;
  display: flex;
  margin-top: auto;

  @media ${media.xl} {
    line-height: 1.1;
  }

  span {
    color: ${({ theme }) => theme.sun};
    margin-left: 10px;
    height: 20px;
    width: 20px;
  }
`

const ArticleTeaser = ({ arrowText, header, text, to, ...props }) => {
  const intl = useIntl()
  return (
    <Teaser to={to} {...props}>
      <TeaserText>
        {header && <h3>{header}</h3>}
        {text && <p>{text}</p>}
      </TeaserText>
      <ReadMore>
        {arrowText || intl.formatMessage({ id: "articles.readMore" })}
        <span>
          <ArrowRightSVG />
        </span>
      </ReadMore>
    </Teaser>
  )
}

ArticleTeaser.propTypes = {
  arrowText: PropTypes.string,
  header: PropTypes.string,
  text: PropTypes.string,
  to: PropTypes.string.isRequired,
}

export default ArticleTeaser
